import React from 'react';
import {
    Plus,
    Pencil,
    Trash2,
    Filter,
    Download,
    Save,
    X,
    Eye,
    MoreHorizontal,
    ChevronRight,
    Copy
} from 'lucide-react';
import styles from './ListingAction.module.css';

/**
 * Enhanced Action Button for Listings
 */
const ListingAction = ({
    label,
    icon,
    onClick,
    variant = 'secondary',
    size = 'md',
    disabled = false,
    loading = false,
    className = '',
    tooltip,
    ...props
}) => {
    const combinedClassName = `
    ${styles.actionButton} 
    ${styles[variant]} 
    ${styles[size]} 
    ${className}
  `.trim();

    return (
        <button
            className={combinedClassName}
            onClick={onClick}
            disabled={disabled || loading}
            title={tooltip || label}
            {...props}
        >
            {loading ? (
                <div className={styles.loadingSpinner} />
            ) : (
                <>
                    {icon && <span className={styles.icon}>{icon}</span>}
                    {label && <span className={styles.label}>{label}</span>}
                </>
            )}
        </button>
    );
};

// --- Subtypes (Convenience Components) ---

export const CreateAction = (props) => (
    <ListingAction
        label="Create New"
        variant="primary"
        icon={<Plus size={18} />}
        {...props}
    />
);

export const EditAction = (props) => (
    <ListingAction
        label="Edit"
        variant="edit"
        icon={<Pencil size={18} />}
        {...props}
    />
);

export const ViewAction = (props) => (
    <ListingAction
        label="View"
        variant="view"
        icon={<Eye size={18} />}
        {...props}
    />
);

export const DeleteAction = (props) => (
    <ListingAction
        label="Delete"
        variant="delete"
        icon={<Trash2 size={18} />}
        {...props}
    />
);

export const SaveAction = (props) => (
    <ListingAction
        label="Save"
        variant="save"
        icon={<Save size={18} />}
        {...props}
    />
);

export const CancelAction = (props) => (
    <ListingAction
        label="Cancel"
        variant="cancel"
        icon={<X size={18} />}
        {...props}
    />
);

export const FilterAction = (props) => (
    <ListingAction
        label="Filter"
        variant="secondary"
        icon={<Filter size={18} />}
        {...props}
    />
);

export const ExportAction = (props) => (
    <ListingAction
        label="Export"
        variant="secondary"
        icon={<Download size={18} />}
        {...props}
    />
);

export const MoreAction = (props) => (
    <ListingAction
        variant="ghost"
        icon={<MoreHorizontal size={18} />}
        {...props}
    />
);

export const DetailsAction = (props) => (
    <ListingAction
        variant="ghost"
        icon={<ChevronRight size={20} />}
        {...props}
    />
);

export const CopyAction = (props) => (
    <ListingAction
        label="Copy"
        variant="secondary"
        icon={<Copy size={18} />}
        {...props}
    />
);

export default ListingAction;
